'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const SocialWhatsappWhiteAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.0854 4.91C17.206 3.03 14.7035 2 12.0402 2C6.55276 2 2.0804 6.45 2.0804 11.91C2.0804 13.66 2.54271 15.36 3.40704 16.86L2 22L7.27638 20.62C8.73367 21.41 10.3719 21.83 12.0402 21.83C17.5276 21.83 22 17.38 22 11.92C22 9.27 20.9648 6.78 19.0854 4.91ZM12.0402 20.15C10.5528 20.15 9.09548 19.75 7.81909 19L7.51759 18.82L4.38191 19.64L5.21608 16.6L5.01508 16.29C4.19095 14.98 3.74874 13.46 3.74874 11.91C3.74874 7.37 7.46734 3.67 12.0301 3.67C14.2412 3.67 16.3216 4.53 17.8794 6.09C19.4472 7.65 20.3015 9.72 20.3015 11.92C20.3216 16.46 16.603 20.15 12.0402 20.15ZM16.5829 13.99C16.3317 13.87 15.1055 13.27 14.8844 13.18C14.6533 13.1 14.4925 13.06 14.3216 13.3C14.1508 13.55 13.6784 14.11 13.5377 14.27C13.397 14.44 13.2462 14.46 12.995 14.33C12.7437 14.21 11.9397 13.94 10.995 13.1C10.2513 12.44 9.75879 11.63 9.60804 11.38C9.46734 11.13 9.58794 11 9.71859 10.87C9.82914 10.76 9.96985 10.58 10.0905 10.44C10.2111 10.3 10.2613 10.19 10.3417 10.03C10.4221 9.86 10.3819 9.72 10.3216 9.6C10.2613 9.48 9.75879 8.26 9.55779 7.76C9.35678 7.28 9.14573 7.34 8.99497 7.33C8.84422 7.33 8.68342 7.33 8.51256 7.33C8.34171 7.33 8.0804 7.39 7.84925 7.64C7.62814 7.89 6.98492 8.49 6.98492 9.71C6.98492 10.93 7.8794 12.11 8 12.27C8.1206 12.44 9.75879 14.94 12.2513 16.01C12.8442 16.27 13.3065 16.42 13.6683 16.53C14.2613 16.72 14.804 16.69 15.2362 16.63C15.7186 16.56 16.7136 16.03 16.9146 15.45C17.1256 14.87 17.1256 14.38 17.0553 14.27C16.9849 14.16 16.8342 14.11 16.5829 13.99Z",
        fill: "white"
      }
    )
  }
);
const VpSocialWhatsappWhiteAsset = forwardRef(SocialWhatsappWhiteAsset);

export { VpSocialWhatsappWhiteAsset as default };
